import SeparateBillLayout from './MonthlyReportLayout';

export default SeparateBillLayout;
